import React,{useState} from 'react'

import './about-component/about.css'

import img2 from './about-component/images/img2.png'
import img3 from './about-component/images/img3.png'

import Top_heading from './component/Top_heading'
import Futuristic_tech from './about-component/Futuristic_tech'
import Maesrtros from './about-component/Maesrtros'
import WeAreDiffrent from './about-component/WeAreDiffrent'
import Services from './about-component/AboutServices'
import GrowYourBusiness from './about-component/GrowYourBusiness'







export default function About() {
  const [activeTab, setActiveTab] = useState('graphics');

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };
  return (
    <>
    
    

    <Top_heading Heading="ABOUT US" para="At Raj Digital Marketing, we specialize in driving growth through smart, data-driven digital strategies. From SEO to social media and web design, our mission is to help businesses thrive online with impactful, result-oriented marketing solutions."/>
    <WeAreDiffrent/>
    


    <Futuristic_tech/>

      <GrowYourBusiness/>
    
      <Services/>
      <Maesrtros/>
      
    </>
  )
}
